import React, { Component } from 'react';
import { Helmet } from "react-helmet";

class Title extends Component{

    render(){
        return(
            <Helmet>
                <meta charSet="utf-8"/>
                <title>Marjanov Milan</title>
             </Helmet>
        )
    }
}

export default Title;